import {
  CheckoutTabHeaderMolecule,
  RoundedCheckboxMolecule,
  StripeCheckoutAppleGooglePaymentMolecule,
  StripeCheckoutCardPaymentMolecule,
  ToastMolecule,
} from '../../molecules';
import React from 'react';
import { usePatientPaymentDetailsStepEffect } from './patient-payment-details-step.effect';
import { PaymentMethods } from '../../../data/subscription/payment-methods';
import { CheckoutPayment, PaypalStatus } from '../../../enums';
import { NotificationMessages } from '../../../enums/notification-messages';
import { CheckoutStepsHeader } from '../../../data/pages/checkout/checkout-steps';

export const PatientPaymentDetailsStepOrganism = () => {
  const {
    paymentMethod,
    paymentRequest,
    paymentRequestOption,
    paymentRequestType,
    setPaymentMethod,
    doPayPalSetup,
    paymentGateway,
    paypal,
    error,
    processing,
    submitPaypalComplete,
    paypalError,
    paypalProcessing,
  } = usePatientPaymentDetailsStepEffect();

  return (
    <section
      data-cy="checkout-payment-details-step-organism"
      className="bg-white py-5 lg:py-0 border-b border-waldo-blue"
    >
      <CheckoutTabHeaderMolecule
        title={CheckoutStepsHeader.REGISTER}
        editable={false}
      />
      <CheckoutTabHeaderMolecule
        title={CheckoutStepsHeader.SHIPPING}
        editable={false}
      />
      <CheckoutTabHeaderMolecule
        title={CheckoutStepsHeader.REVIEW}
        editable={false}
      />

      <div className="py-8 w-11/12 lg:w-full mx-auto">
        {paypalError && (
          <div className="text-waldo-tangerine text-sm font-medium mb-5">
            <ToastMolecule
              toastList={[
                {
                  id: 1,
                  title: CheckoutPayment.PAYMENT_FAILED,
                  description: paypalError as string,
                  bgColor: 'bg-waldo-poppy',
                  icon: 'warning',
                },
              ]}
              position="Top-Left"
              autoDelete={true}
              autoDeleteTime={8000}
            />
          </div>
        )}

        <h1 className="text-tabTitle font-normal font-waldo-regular no-underline">
          {CheckoutStepsHeader.PAYMENT}
        </h1>
        <div className="mb-3 mt-3">
          <div className="flex flex-row w-full justify-between">
            <RoundedCheckboxMolecule
              label="Credit Card"
              labelClass="font-normal w-2/5"
              checked={
                paymentMethod === PaymentMethods.STRIPE ||
                paymentGateway === PaymentMethods.STRIPE
              }
              setAsChecked={() => setPaymentMethod(PaymentMethods.STRIPE)}
              name="paymentMethodToggle"
              value={0}
            />

            <div className="w-3/5 flex flex-1 align-top">
              <img
                src="/images/checkout/payment/checkout-visa.svg"
                alt="Visa"
                className="mr-5"
                width="38"
              />

              <img
                src="/images/checkout/payment/checkout-mastercard.svg"
                alt="Mastercard"
                className="mr-5"
                width="29"
              />

              <img
                src="/images/checkout/payment/checkout-amex.svg"
                className=""
                alt="Amex"
                width="36"
              />
            </div>
          </div>
          {paymentMethod === PaymentMethods.STRIPE && (
            <StripeCheckoutCardPaymentMolecule />
          )}

          {paymentRequest && (
            <>
              {paymentRequestType.applePay && (
                <RoundedCheckboxMolecule
                  label="Pay with Apple Pay"
                  labelImage="/images/checkout/payment/checkout-apple-pay.svg"
                  checked={
                    paymentMethod === PaymentMethods.APPLE_PAY ||
                    paymentGateway === PaymentMethods.APPLE_PAY
                  }
                  setAsChecked={() =>
                    setPaymentMethod(PaymentMethods.APPLE_PAY)
                  }
                  name="paymentMethodToggle"
                  value={2}
                />
              )}

              {paymentMethod === PaymentMethods.APPLE_PAY &&
                paymentRequest &&
                paymentRequestType.applePay && (
                  <StripeCheckoutAppleGooglePaymentMolecule
                    paymentRequestOptions={paymentRequestOption}
                    method="Apple Pay"
                    page="checkout"
                  />
                )}

              {paymentRequestType.googlePay && (
                <RoundedCheckboxMolecule
                  label="Pay with Google Pay"
                  labelImage="/images/checkout/payment/checkout-google-pay.svg"
                  checked={
                    paymentMethod === PaymentMethods.GOOGLE_PAY ||
                    paymentGateway === PaymentMethods.GOOGLE_PAY
                  }
                  setAsChecked={() =>
                    setPaymentMethod(PaymentMethods.GOOGLE_PAY)
                  }
                  name="paymentMethodToggle"
                  value={3}
                />
              )}

              {paymentMethod === PaymentMethods.GOOGLE_PAY &&
                paymentRequest &&
                paymentRequestType.googlePay && (
                  <StripeCheckoutAppleGooglePaymentMolecule
                    paymentRequestOptions={paymentRequestOption}
                    method="Google Pay"
                    page="checkout"
                  />
                )}
            </>
          )}
          <RoundedCheckboxMolecule
            label="Pay with PayPal"
            labelImage="/images/checkout/payment/checkout-paypal.svg"
            checked={
              paymentMethod === PaymentMethods.PAYPAL ||
              paymentGateway === PaymentMethods.PAYPAL
            }
            setAsChecked={() => doPayPalSetup()}
            name="paymentMethodToggle"
            value={1}
          />

          {paymentMethod === PaymentMethods.PAYPAL && processing && (
            <p className="mt-5 text-waldo-tangerine">
              Redirecting to Paypal...
            </p>
          )}

          {!error &&
            paymentGateway === PaymentMethods.PAYPAL &&
            paypal.paypalStatus === PaypalStatus.COMPLETED && (
              <div>
                <p className="mt-5 text-waldo-blue">Payment Method: Paypal</p>
                <div className="flex flex-col w-full items-center mt-5">
                  <button
                    className="button btn-cta w-full lg:w-3/4 mt-5 mb-10"
                    onClick={submitPaypalComplete}
                  >
                    <span id="button-text">
                      {paypalProcessing
                        ? CheckoutPayment.CARD_PROCESSING
                        : CheckoutPayment.CARD_SUCCESSFUL}
                    </span>
                  </button>
                </div>
              </div>
            )}

          {error && (
            <div className="text-waldo-tangerine text-sm font-medium mb-5">
              <ToastMolecule
                toastList={[
                  {
                    id: 1,
                    title: NotificationMessages.CHECKOUT_PAYPAL_ERROR,
                    description: error,
                    bgColor: 'bg-waldo-poppy',
                    icon: 'warning',
                  },
                ]}
                position="Bottom-Right"
                autoDelete={true}
                autoDeleteTime={8000}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
